<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="cn"><span class="epub-b">CONTENTS</span></p>
<p class="tx"> </p>
<p class="tx"> </p>
<p class="tx"> </p>
<p class="cct">      <span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="cct">      <span href="#/xhtml/dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="cct-bot">      <a href="#/xhtml/foreword#for">Foreword by Mary Wells Lawrence</a></p>
<p class="cct">  <a href="#/xhtml/chapter1#ch1"><span class="epub-b">1</span>  A Day on Madison Avenue, 1967</a></p>
<p class="cct">  <span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample"><span class="epub-b">2</span>  Sex in the Office</span></p>
<p class="cct">  <span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample"><span class="epub-b">3</span>  “Get the Money Before They Screw You”</span></p>
<p class="cct">  <span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample"><span class="epub-b">4</span>  Women and Children Last</span></p>
<p class="cct">  <span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample"><span class="epub-b">5</span>  The Three-Martini Lunch and Other Vices</span></p>
<p class="cct">  <span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample"><span class="epub-b">6</span>  A Different Century, a Different World</span></p>
<p class="cct">  <span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample"><span class="epub-b">7</span>  Bang Bang, You’re Dead (the Creative Revolution Kills)</span></p>
<p class="cct">  <span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample"><span class="epub-b">8</span>  Sex in Advertising</span></p>
<p class="cct">  <span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample"><span class="epub-b">9</span>  Why I Love New York</span></p>
<p class="cct"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample"><span class="epub-b">10</span>  The Queen and I</span></p>
<p class="cct"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample"><span class="epub-b">11</span>  Have You Really Come Such a Long Way, Baby?</span></p>
<p class="cct-bot">      <span href="#/xhtml/epilogue#epi" title="Link target outside of Sample">Epilogue: The War Over <span class="epub-i">Mad Men</span></span></p>
<p class="cct">      <span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
<p class="cct">      <span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="cct">      <span href="#/xhtml/adcard#adc" title="Link target outside of Sample">Also by Jane Maas</span></p>
<p class="cct">      <span href="#/xhtml/about_the_author#aut" title="Link target outside of Sample">About the Author</span></p>
<p class="cct">      <span href="#/xhtml/copyright#copy" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1dc778d5